import React, { Component } from 'react';
import Input from '../component/Input.js';
import SelectBox from '../component/Select.js';
import axios from 'axios';
import {path, loginPath} from './routes.js';
import Validation from './Validation.js'; //used for validation

export default class SetUserLogin extends Component {
	constructor(props){
		super(props);
		this.handleInput = this.handleInput.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.state = {questions:[],password:'',question:'',answer:'',confirm:'',confirmed:true,prompt:''};
	}

	handleInput(identity,value){ //standard method for handling user input
		const theState = {};
		theState[identity] = value;
		this.setState(theState);
	}

	componentDidMount(){ //when component mounts, retrieve list of security questions
		axios({
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'question'}
		}).then((response)=>{
			let data = response.data.data;
			this.setState({questions:data});
			this.setState({question:data[0].Question,password:'@#^$%!&*',confirm:''});
		});
	}

	componentDidUpdate(){
		if(!this.state.confirmed && this.state.password.trim() !== '' && this.state.password === this.state.confirm){ //if confirm password field is the same as password field
			this.setState({confirmed:true});
		}else if(this.state.confirmed && this.state.password !== this.state.confirm){ //if confirm password field is NOT the same as password field
			this.setState({confirmed:false});
		}
	}

	onSubmit(){ //method for submitting updated security information for new user
		const {questions,password,question,answer,confirm,confirmed} = this.state;
		if(password.trim() !== '' && question.trim() !== '' && answer.trim() !== '' && confirmed && password.trim() === confirm.trim() && Validation("pword",password.trim())){ //if all input fields are filled out and contain valid input, continue
			let qID;
			questions.filter((secquestions)=>{ //get the Id for the selected security question
				if (question === secquestions.Question){
					qID = secquestions.Id;
					return;
				}
			});
			let info = this.props.info;
			axios({
				method:'post',
				url:loginPath,
				headers:{'Content-Type':'application/json'},
				//data:{endpoint:'create',table:'users',misc:'security',status:password.trim(),answer:answer.trim().toLowerCase(),firstID:info.userID,secondID:qID}
				data:{action:'security',password:password.trim(),answer:answer.trim().toLowerCase(),firstID:info.userID,secondID:qID}
			}).then((response)=>{
				console.log(response);
				let data = response.data.data;
				if(data.Message === "success"){
					this.props.success(true,info);
					this.props.close();
				}
			}).catch((err) => console.log(err));
		}else{ //set error message if any fields are blank or contain invalid input
			this.setState({prompt:"Please fill out all fields correctly."});
		}
	}

	render(){
		let secQuestions = this.state.questions.map((questions)=>{
			return questions.Question;
		});
		const selectStyles = "h2 pa1 br2 bw1 truncate w-100 shadow-3";
		const inputStyles = "h2 pl3 br2 bw1 w-100 shadow-3 b--light-silver";
		const labelStyles = "fl w-100 tl pr4-ns b navy f5 mt3";
		const inputDiv = "fl w-100 tl pt2";
		const outerDiv = "mb5 pb3";
		let confirmStyle = inputStyles;
		let confirmSpan;
		let prompt;
		if(this.state.prompt !== ''){
			prompt = <span className="red">*{this.state.prompt}</span>;
		}
		if(this.state.confirm.trim() !== '' && !this.state.confirmed){ //highlight red if confirm password field does not equal the password field
			confirmStyle = "h2 pl3 br2 bw1 w-100 shadow-3 b--red";
			confirmSpan = <span className="red"> *</span>;
		}else if(this.state.confirmed){  //highlight green if confirm password field equals the password field
			confirmStyle = "h2 pl3 br2 bw1 w-100 shadow-3 b--green";
			confirmSpan = <span className="green"> *</span>;
		}
		return(
			<div style={{width:'90%',margin:'auto'}}>
				<h1 className="f3 b navy tc">Security Information</h1>
				<div className={outerDiv}>
					<div className={labelStyles}>
						<label>New Password: {prompt}</label>
					</div>
					<div className={inputDiv}>
						<Input identity="password" inputStyle={inputStyles} onInput={this.handleInput} type="password"/>
					</div>
				</div>

				<div className={outerDiv}>
					<div className={labelStyles}>
						<label>Confirm Password:{confirmSpan}</label>
					</div>
					<div className={inputDiv}>
						<Input identity="confirm" inputStyle={confirmStyle} onInput={this.handleInput} type="password"/>
					</div>
				</div>

				<div className={outerDiv}>
					<div className={labelStyles}>
						<label>Security Question:</label>
					</div>
					<div className={inputDiv}>
						<SelectBox identity="question" onSelect={this.handleInput} options={secQuestions} styles={selectStyles} val={this.state.question}/>
					</div>
				</div>

				<div className={outerDiv}>
					<div className={labelStyles}>
						<label>Security Answer:</label>
					</div>
					<div className={inputDiv}>
						<Input identity="answer" inputStyle={inputStyles} onInput={this.handleInput}/>
					</div>
				</div>
				<div className="fl w-100 tc mt3 mb3">
					<button className="fc w-40-ns w-100 br3 h2 shadow-3 bg-navy white" onClick={this.onSubmit}>Submit</button>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/SetUserLogin.js